import { Card } from "components/styles";
import styled from "styled-components";

export const Wrapper = styled(Card)`
  margin: 1rem 2rem 2rem 2rem;
`;

export const Heading = styled.p`
  text-align: center;
  font-size: 2rem;
  font-weight: 600;
`;

export const Subheading = styled.p`
  text-align: center;
  font-size: 0.75rem;
`;

export const Actions = styled.div`
  button {
    margin-top: 1rem;
  }
`;
